import { SidebarAndModalContext } from '@/context/sidebarAndModal';
import { CSSObject } from '@emotion/serialize';
import { Drawer } from '@mui/material';
import { useTheme, Theme } from '@mui/material/styles';
import { useContext } from 'react';
import { SidebarItems } from './items';
import { AppRouters } from '@/utils/constants/routers';
import { useNavigate } from 'react-router-dom';
import { Text } from '@/components/atoms/text';
import { LogoButton, LogoWrapper } from './styles';

const drawerWidth = '68px';

const closedMenu = (theme: Theme): CSSObject => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.shortest,
  }),
  overflowX: 'hidden',
  zIndex: theme.zIndex.speedDial,
  top: 'auto',
  padding: `0 ${theme.spacing(0.5)}`,
});

const openedMenu = (theme: Theme): CSSObject => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  display: 'flex',
  width: theme.spacing(36),
  zIndex: theme.zIndex.speedDial,
  top: 'auto',
  padding: `0 ${theme.spacing(0.5)}`,
});

export const Sidebar = () => {
  const { open, handleDrawerClose, handleDrawerOpen } = useContext(SidebarAndModalContext);
  const navigate = useNavigate();
  const theme = useTheme();

  return (
    <Drawer
      onMouseMove={handleDrawerOpen}
      onMouseLeave={handleDrawerClose}
      variant="permanent"
      open={!open}
      sx={{
        width: drawerWidth,
        height: '100vh',
        flexShrink: 0,
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        '& .MuiDrawer-paper': {
          overflowX: 'hidden',
          overflowY: 'auto',
          height: '100vh',
          position: 'fixed',
          display: 'flex',
          flexDirection: 'column',
        },
        [theme.breakpoints.up('sm')]: {
          ...(open && {
            ...openedMenu(theme),
            '& .MuiDrawer-paper': openedMenu(theme),
          }),
          ...(!open && {
            ...closedMenu(theme),
            '& .MuiDrawer-paper': closedMenu(theme),
          }),
        },
        [theme.breakpoints.down('md')]: {
          ...(open && {
            ...openedMenu(theme),
            '& .MuiDrawer-paper': openedMenu(theme),
          }),
          ...(!open && {
            display: 'none',
          }),
        },
      }}
    >
      <LogoWrapper open={open}>
        <LogoButton onClick={() => navigate(AppRouters.home)} open={open}>
          <img src="/img/svg/logos/logo_kyt.svg" alt="logo" />
        </LogoButton>
        <Text variant="subtitle1">Know Your Territory</Text>
      </LogoWrapper>

      <SidebarItems />
    </Drawer>
  );
};
